var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loaded && !_vm.isLineLeaderEnroll)?_c('layout'):_vm._e(),(_vm.loaded && _vm.isLineLeaderEnroll)?_c('layout-m-p'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }